import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Dropdown,
    Label,
    Dimmer,
    Loader,
} from "semantic-ui-react";
import config from "../../../config.js";
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import {
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    ListSubheader,
    TextField,
    InputAdornment,
    ListItemText,
    Checkbox
} from "@mui/material";
import OutlinedInput from '@mui/material/OutlinedInput';
import SearchIcon from "@mui/icons-material/Search";
import ReactTable from "react-table-v6";
import moment from "moment";

import {
    fetchTemplates,
    getPSRChannelList,
    psrCustomReportPivotData,
    psrCustomReportData,
    psrCustomReportGeneration,
    getPsrCustomReports,
    getPsrSiteName,
    psrUpdateChannels
} from '../../../actions/users_action';

const storageBaseUrl = config["storage_base_url"];

const ITEM_HEIGHT = 38;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 3.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


class PSRReport extends React.Component {
    constructor(props) {
        super(props);
        this.historyPollInterval = null;
        this.historyPollTimeout = null;
        this.channelUpdateRequested = {};   // templateIds already sent to psrUpdateChannels
        this.state = {
            templateId: "",
            distributors: [],
            selectedDistributor: [],
            selectedTemplate: '',
            templates: [],
            selectedType: ['LEAP', 'SubD'],
            transactionTypes: [],
            channel: [],
            category: [],
            brand: [],
            brandform: [],
            filteredBrand: [],
            filteredBrandform: [],
            selectedChannel: [],
            selectedBrand: [],
            selectedBrandform: [],
            selectedCategory: [],
            selectedTransactionType: [],
            filteredData: [],
            filetrCol: [],
            selectedFilterColumns: [],
            selectedfilterValue: {},
            placeholder: '',
            key: '',
            value: [],
            finalReportUrl: '',
            history: [],
            processingTemplateIds: [],
            searchTexts: {},
            startDate: null,
            endDate: null,
            loaderStatus: false
        };
    }

    componentWillUnmount() {
        this.stopHistoryPolling();
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                if (Array.isArray(res.templates) && res.templates.length > 0) {
                    const latestTemplate = res.templates[res.templates.length - 1]
                    this.setState({
                        templates: res.templates,
                        templateId: latestTemplate['_id'],
                        selectedTemplate: latestTemplate['name'],
                        fileTemplates: latestTemplate['fileTemplates']
                    })
                    res.templates.forEach((template) => this.loadCustomReports(template['_id']))
                    this.loadSiteName(latestTemplate['_id'], this.state.selectedType)
                    this.loadChannelList(latestTemplate['_id'])
                }
            },
            onFailure: () => { }
        })
    }

    // ───────────── channel / filter lists (per template) ─────────────

    loadChannelList = (templateId, keepSelections = false) => {
        if (!templateId) return;

        this.props.getPSRChannelList(templateId, {
            onSuccess: (res) => {
                const transactionTypes = res.transactionType || [];
                const channel = res.channelList || [];
                const category = res.category || [];
                const brand = res.brand || [];
                const brandform = res.brandform || [];
                const selectedCategory = keepSelections
                    ? this.state.selectedCategory.filter(value => category.includes(value))
                    : category;
                const filteredBrand = this.getBrandsForCategories(selectedCategory, brand);
                const selectedBrand = keepSelections
                    ? this.state.selectedBrand.filter(value => filteredBrand.includes(value))
                    : filteredBrand;
                const filteredBrandform = this.getBrandformsForBrands(selectedBrand, brandform);
                this.setState({
                    channel,
                    transactionTypes,
                    category,
                    brand,
                    brandform,
                    selectedTransactionType: keepSelections
                        ? this.state.selectedTransactionType.filter(value => transactionTypes.includes(value))
                        : transactionTypes,
                    selectedChannel: keepSelections
                        ? this.state.selectedChannel.filter(value => channel.includes(value))
                        : channel,
                    selectedCategory,
                    selectedBrand,
                    selectedBrandform: keepSelections
                        ? this.state.selectedBrandform.filter(form => filteredBrandform.includes(form))
                        : filteredBrandform,
                    filteredBrand,
                    filteredBrandform,
                    selectedFilterColumns: keepSelections
                        ? this.state.selectedFilterColumns.filter(value => (res.columns || []).includes(value))
                        : (res.columns || []),
                    filetrCol: res.columns || [],
                });
            },
            onFailure: () => {
                this.setState({
                    channel: [],
                    transactionTypes: [],
                    category: [],
                    brand: [],
                    brandform: [],
                    filteredBrand: [],
                    filteredBrandform: [],
                    filetrCol: []
                })
            }
        })
    }

    // Called when the Channel dropdown is opened: POST psrUpdateChannels (once per template)
    onChannelOpen = () => {
        const templateId = this.state.templateId;
        if (!templateId || this.channelUpdateRequested[templateId]) return;

        this.channelUpdateRequested[templateId] = true;
        this.props.psrUpdateChannels(templateId, {
            onSuccess: () => {
                // the Celery task runs in the background, so reload once after a short wait
                setTimeout(() => {
                    if (this.state.templateId === templateId) this.loadChannelList(templateId, true)
                }, 8000)
            },
            onFailure: () => {
                this.channelUpdateRequested[templateId] = false   // allow a retry
            }
        })
    }

    // ───────────── history + polling ─────────────

    loadCustomReports = (templateId) => {
        if (!templateId) return;

        this.props.getPsrCustomReports(templateId, {
            onSuccess: (res) => {
                const historyRows = Array.isArray(res.data) ? res.data : [];
                this.updateTemplateProcessingStatus(templateId, historyRows);
                if (this.state.templateId === templateId) {
                    this.setState({ history: historyRows });
                }
            },
            onFailure: () => {
                if (this.state.templateId === templateId) {
                    this.setState({ history: [] });
                }
            }
        })
    }

    updateTemplateProcessingStatus = (templateId, historyRows = []) => {
        this.setTemplateProcessing(templateId, this.getLatestReportStatus(historyRows) === 'processing');
    }

    setTemplateProcessing = (templateId, isProcessing) => {
        this.setState((prevState) => {
            const processingTemplateIds = new Set(prevState.processingTemplateIds);
            if (isProcessing) {
                processingTemplateIds.add(templateId);
            } else {
                processingTemplateIds.delete(templateId);
            }
            return { processingTemplateIds: Array.from(processingTemplateIds) };
        });
    }

    getLatestReportStatus = (historyRows = []) => {
        if (!Array.isArray(historyRows) || historyRows.length === 0) return '';
        return (historyRows[0].status || '').toLowerCase();
    }

    stopHistoryPolling = () => {
        if (this.historyPollInterval) {
            clearInterval(this.historyPollInterval);
            this.historyPollInterval = null;
        }
        if (this.historyPollTimeout) {
            clearTimeout(this.historyPollTimeout);
            this.historyPollTimeout = null;
        }
    }

    fetchHistoryAndUpdatePolling = (templateId) => {
        if (!templateId) return;

        this.props.getPsrCustomReports(templateId, {
            onSuccess: (res) => {
                const historyRows = Array.isArray(res.data) ? res.data : [];
                const latestStatus = this.getLatestReportStatus(historyRows);

                this.updateTemplateProcessingStatus(templateId, historyRows);
                if (this.state.templateId === templateId) {
                    this.setState({ history: historyRows });
                }

                if (latestStatus === 'completed' || latestStatus === 'failed') {
                    this.stopHistoryPolling();
                }
            },
            onFailure: () => {
                this.setState({ history: [] })
            }
        })
    }

    startHistoryPolling = (templateId) => {
        if (!templateId) return;

        this.stopHistoryPolling();

        // Hit once immediately after generate, then poll every 1 minute.
        this.fetchHistoryAndUpdatePolling(templateId);

        this.historyPollInterval = setInterval(() => {
            this.fetchHistoryAndUpdatePolling(templateId);
        }, 60 * 1000);

        // Stop polling after 5 minutes
        this.historyPollTimeout = setTimeout(() => {
            this.stopHistoryPolling();
        }, 5 * 60 * 1000);
    }

    // ───────────── distributors (only from getPsrSiteName) ─────────────

    loadSiteName = (templateId, fileType = '') => {
        if (!templateId) return;

        this.props.getPsrSiteName(templateId, {
            onSuccess: (res) => {
                let siteNameRows = Array.isArray(res.data) ? res.data : [];

                // Filter by selected file type(s) if any
                const types = (Array.isArray(fileType) ? fileType : [fileType])
                    .filter(Boolean)
                    .map((t) => String(t).toUpperCase());
                if (types.length > 0) {
                    siteNameRows = siteNameRows.filter((row) =>
                        types.includes((row.fileType || '').toUpperCase())
                    );
                }

                const siteNames = siteNameRows
                    .map((row) => this.getSiteNameFromRecord(row))
                    .filter(Boolean);
                const uniqSiteNames = [...new Set(siteNames)];

                this.setState({
                    distributors: uniqSiteNames.length > 0 ? [...uniqSiteNames, 'ALL'] : [],
                    selectedDistributor: uniqSiteNames.length > 0 ? [...uniqSiteNames, 'ALL'] : []
                });
            }
        });
    }

    getSiteNameFromRecord = (record = {}) => {
        return (record.siteName && typeof record.siteName === 'string')
            ? record.siteName.trim()
            : '';
    }

    // ───────────── change handlers ─────────────

    dropDownTemplateOnChange = (event) => {
        const value = event.target.value;

        this.setState({ selectedTemplate: value })

        this.state.templates.forEach((d) => {
            if (d.name == value) {
                this.setState({
                    templateId: d._id,
                    selectedType: ['LEAP', 'SubD']
                })
                this.loadCustomReports(d._id)
                this.loadSiteName(d._id, ['LEAP', 'SubD'])
                this.loadChannelList(d._id)
            }
        })
    }

    onTypeChanged = (types) => {
        if (this.state.templateId) {
            this.loadSiteName(this.state.templateId, types)
        }
    }

    handleStartDateChange = (e, data) => {
        this.setState({ startDate: data.value });
    }

    handleEndDateChange = (e, data) => {
        this.setState({ endDate: data.value });
    }

    // ───────────── generate report ─────────────

    fetchData = () => {
        // helper to format date without timezone shift
        const formatDate = (date, isEnd = false) => {
            if (!date) return undefined;
            const d = new Date(date);
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return isEnd
                ? `${yyyy}-${mm}-${dd}T23:59:59.999Z`
                : `${yyyy}-${mm}-${dd}T00:00:00.000Z`;
        };

        const s = this.state;

        const processingTemplateId = s.processingTemplateIds.find((id) => id !== s.templateId);
        if (processingTemplateId) {
            alert('A report for another month is processing. Please start this report once it is complete.');
            return;
        }
        if (this.isReportProcessing() || s.loaderStatus) {
            return;
        }

        // the backend treats all of these as required
        const checks = [
            [s.selectedType.length > 0, 'Please Select Type'],
            [s.selectedTemplate !== '', 'Please Select Month'],
            [s.selectedDistributor.length > 0, 'Please Select Distributor'],
            [s.selectedTransactionType.length > 0, 'Please Select Transaction Type'],
            [s.selectedChannel.length > 0, 'Please Select Channel'],
            [s.selectedCategory.length > 0, 'Please Select Category'],
            [s.selectedBrand.length > 0, 'Please Select Brand'],
            [!!s.startDate, 'Please Select Start Date'],
            [!!s.endDate, 'Please Select End Date'],
            [s.selectedFilterColumns.length > 0, 'Please Select Columns'],
        ];
        const failed = checks.find(([ok]) => !ok);
        if (failed) {
            alert(failed[1]);
            return;
        }

        this.setTemplateProcessing(s.templateId, true);
        this.setState({ loaderStatus: true })
        const data = {
            templateId: s.templateId,
            siteName: s.selectedDistributor,
            channels: s.selectedChannel,
            startDate: formatDate(s.startDate, false),
            endDate: formatDate(s.endDate, true),
            fileType: s.selectedType,
            transactionType: s.selectedTransactionType,
            columns: s.selectedFilterColumns,
            category: s.selectedCategory,
            brand: s.selectedBrand,
            brandform: s.selectedBrandform
        }

        this.props.psrCustomReportGeneration(data, {
            onSuccess: (res) => {
                this.setState({
                    loaderStatus: false,
                    finalReportUrl: res && res.result_sep ? res.result_sep : s.finalReportUrl,
                })
                this.startHistoryPolling(s.templateId)
            },
            onFailure: () => {
                this.stopHistoryPolling();
                this.setTemplateProcessing(s.templateId, false);
                this.setState({ loaderStatus: false })
            }
        })
    }

    // ───────────── pivot dropdown helpers (unchanged logic) ─────────────

    handleDropdownChange = (key, value) => {
        const setValue = () => this.setState(prevState => ({
            selectedfilterValue: {
                ...prevState.selectedfilterValue,
                [key]: value
            }
        }));

        if (this.state.placeholder.includes('0')) {
            setValue();
            this.setState({ key: key, value: value })
        }
        else if (this.state.placeholder.includes('1')) {
            setValue();
            this.setState({ isFirstTime: false, key: key, value: value })
        }
        else if (this.state.placeholder.includes('2')) {
            setValue();
            this.setState({ isFirstTime: true })
        }
        else if (this.state.placeholder.includes('3')) {
            setValue();
            this.setState({ isFirstTime: false })
        }
    };

    filterFun = (key, value) => {
        const filteredData = this.state.filteredData.filter(item => value.includes(item[key]));
        this.setState({ filteredData: filteredData })
    }

    handleDropdownClick = (e, data) => {
        if (!data.placeholder.includes('0')) {
            this.filterFun(this.state.key, this.state.value)
        }
        this.setState({ placeholder: data.placeholder })
    }

    // ───────────── downloads ─────────────

    downloadReport = () => {
        window.open(storageBaseUrl + this.state.finalReportUrl);
    }

    downloadHistoryfile = fileUrl => {
        const url = typeof fileUrl === 'string' && fileUrl.startsWith('http')
            ? fileUrl
            : storageBaseUrl + fileUrl;
        window.open(url);
    }

    // ───────────── shared multi-select (with Select All / Unselect All) ─────────────

    selectAllValue = '__SELECT_ALL__';

    setSearchText = (id, text) => {
        this.setState(prev => ({ searchTexts: { ...prev.searchTexts, [id]: text } }));
    }

    getVisibleOptions = (id, options = []) => {
        const text = ((this.state.searchTexts || {})[id] || '').trim().toLowerCase();
        if (!text) return options;
        return options.filter(o => String(o).toLowerCase().includes(text));
    }

    // Handles normal select/unselect plus the "Select All" toggle
    applyMultiSelect = (stateKey, value, selectable, after) => {
        const current = this.state[stateKey] || [];
        let next = typeof value === 'string' ? value.split(',') : value;

        if (next.includes(this.selectAllValue)) {
            const allSelected = selectable.length > 0 && selectable.every(o => current.includes(o));
            next = allSelected
                ? current.filter(c => !selectable.includes(c))            // unselect all visible
                : [...new Set([...current, ...selectable])];              // select all visible
        }

        this.setState({ [stateKey]: next }, () => { if (after) after(next); });
    }

    onCategoryChanged = (categories) => {
        const uniq = this.getBrandsForCategories(categories);
        this.setState(prev => {
            const selectedBrand = prev.selectedBrand.filter(b => uniq.includes(b));
            const filteredBrandform = this.getBrandformsForBrands(selectedBrand);
            return {
                filteredBrand: uniq,
                selectedBrand,
                filteredBrandform,
                selectedBrandform: prev.selectedBrandform.filter(form => filteredBrandform.includes(form))
            };
        });
    }

    getBrandsForCategories = (categories, brandOptions = this.state.brand) => {
        const brands = [];
        categories.forEach(category => {
            const found = (brandOptions || []).find(item => category in item);
            if (found) brands.push(...found[category]);
        });
        return [...new Set(brands)];
    }

    getBrandformsForBrands = (brands, brandformOptions = this.state.brandform) => {
        const brandforms = [];
        brands.forEach(brand => {
            const found = (brandformOptions || []).find(item => brand in item);
            if (found) brandforms.push(...found[brand]);
        });
        return [...new Set(brandforms)];
    }

    onBrandChanged = (brands) => {
        const filteredBrandform = this.getBrandformsForBrands(brands);
        this.setState(prev => ({
            filteredBrandform,
            selectedBrandform: prev.selectedBrandform.filter(form => filteredBrandform.includes(form))
        }));
    }

    resetFilters = () => {
        this.setState({
            selectedType: [],
            selectedDistributor: [],
            selectedTransactionType: [],
            selectedChannel: [],
            selectedCategory: [],
            selectedBrand: [],
            selectedBrandform: [],
            filteredBrand: [],
            filteredBrandform: [],
            selectedFilterColumns: [],
            startDate: null,
            endDate: null,
            searchTexts: {}
        });
    }

    renderMultiSelect = ({
        id, label, stateKey, options = [],
        searchable = true, exclude = [], emptyText = 'No options', onAfterChange, onOpen
    }) => {
        const selected = this.state[stateKey] || [];
        const visible = this.getVisibleOptions(id, options);
        const selectable = visible.filter(o => !exclude.includes(o));
        const selectedInView = selectable.filter(o => selected.includes(o)).length;
        const allSelected = selectable.length > 0 && selectedInView === selectable.length;
        const someSelected = selectedInView > 0 && !allSelected;

        const items = [];

        if (searchable) {
            items.push(
                <ListSubheader key="__search" sx={{ p: 1 }}>
                    <TextField
                        size="small"
                        autoFocus
                        fullWidth
                        placeholder="Type to search..."
                        value={(this.state.searchTexts || {})[id] || ''}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            )
                        }}
                        onChange={(e) => this.setSearchText(id, e.target.value)}
                        onKeyDown={(e) => { if (e.key !== 'Escape') e.stopPropagation(); }}
                    />
                </ListSubheader>
            );
        }

        if (selectable.length > 0) {
            items.push(
                <MenuItem key="__all" value={this.selectAllValue} divider>
                    <Checkbox size="small" checked={allSelected} indeterminate={someSelected} />
                    <ListItemText
                        primary={allSelected ? 'Unselect All' : 'Select All'}
                        primaryTypographyProps={{ fontWeight: 600 }}
                    />
                </MenuItem>
            );
        }

        visible.forEach((name) => {
            items.push(
                <MenuItem key={name} value={name}>
                    <Checkbox size="small" checked={selected.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                </MenuItem>
            );
        });

        if (visible.length === 0) {
            items.push(
                <MenuItem key="__empty" disabled>
                    {options.length === 0 ? emptyText : 'No matches found'}
                </MenuItem>
            );
        }

        return (
            <FormControl size="small" fullWidth>
                <InputLabel id={`${id}-label`}>{label}</InputLabel>
                <Select
                    labelId={`${id}-label`}
                    id={id}
                    multiple
                    value={selected}
                    onChange={(e) => this.applyMultiSelect(stateKey, e.target.value, selectable, onAfterChange)}
                    onOpen={onOpen}
                    onClose={() => this.setSearchText(id, '')}
                    input={<OutlinedInput label={label} />}
                    renderValue={(sel) =>
                        options.length > 0 && sel.length === options.length
                            ? 'All'
                            : sel.length > 2 ? `${sel.length} selected` : sel.join(', ')
                    }
                    MenuProps={{ autoFocus: false, PaperProps: { style: { maxHeight: 320, minWidth: 260 } } }}
                >
                    {items}
                </Select>
            </FormControl>
        );
    }

    isReportProcessing = () => {
        return this.state.processingTemplateIds.includes(this.state.templateId);
    }

    render() {
        const templateMonths = this.state.templates.map((d) => d.name)

        const columns = [
            {
                Header: "Generated At",
                Cell: (row) => (
                    <div style={{ textAlign: 'center' }}>
                        {row.original.generatedAt
                            ? moment.utc(row.original.generatedAt).utcOffset(330).format('YYYY-MM-DD HH:mm:ss')
                            : `${row.original.date || ''} ${row.original.time || ''}`}
                    </div>
                ),
            },
            {
                Header: "Status",
                Cell: (row) => {
                    const status = row.original.status || '-';
                    const errorMessage = row.original.errorMessage;
                    const isFailed = status.toLowerCase() === 'failed';
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ textTransform: 'capitalize' }}>{status}</div>
                            {isFailed && errorMessage && (
                                <div
                                    title={errorMessage}
                                    style={{
                                        color: 'black',
                                        fontSize: 11,
                                        marginTop: 2,
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word'
                                    }}
                                >
                                    ({errorMessage})
                                </div>
                            )}
                        </div>
                    );
                },
            },
            {
                Header: "Rows",
                Cell: (row) => (
                    <div style={{ textAlign: 'center' }}>
                        {row.original.rowCount || 0}
                    </div>
                ),
            },
            {
                Header: "Processed File Link",
                Cell: (row) => (
                    <div style={{ textAlign: 'center' }}>
                        <Icon
                            name="download"
                            onClick={() => this.downloadHistoryfile(row.original.fileUrl || row.original.processedFileUrl)}
                            style={{
                                width: 100,
                                cursor: "pointer",
                                color: "green",
                            }}
                        />
                    </div>
                ),
            },
        ]

        const fileType = ['LEAP', 'SubD']

        const allKeys = this.state.filteredData.reduce((keys, item) => {
            Object.keys(item).forEach(key => {
                if (!keys.includes(key)) {
                    keys.push(key);
                }
            });
            return keys;
        }, []);

        // Generate dynamic dropdowns based on keys and dependencies
        const dropdowns = allKeys.map((key, index) => {
            const uniqueValues = Array.from(new Set(this.state.filteredData.map(item => item[key]).filter(Boolean)));
            const options = uniqueValues.map(value => ({
                key: value,
                text: value,
                value: value
            }));

            const dependentKeys = allKeys.slice(0, index);
            const dependentValues = dependentKeys.map(dependentKey => this.state.selectedfilterValue[dependentKey]);

            return (
                <Dropdown
                    key={key}
                    placeholder={`Select ${key} ${index}`}
                    fluid
                    multiple
                    search
                    selection
                    options={options}
                    onClick={this.handleDropdownClick}
                    onChange={(event, { value }) => this.handleDropdownChange(key, value)}
                    value={this.state.selectedfilterValue[key] || []}
                    disabled={dependentValues.some(dependentValue => !dependentValue)}
                />
            );
        });

        return (
            <div>
                <style>{`
                    .psr-date-field .field { margin: 0 !important; }
                    .psr-date-field .ui.input,
                    .psr-date-field .ui.input input { width: 100% !important; }
                    .psr-date-field .ui.input input { height: 40px; }
                    .psr-date-field label { font-size: 12px !important; color: #666 !important; font-weight: 400 !important; }
                `}</style>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Dimmer active={this.state.loaderStatus}>
                        <Loader size="massive">File Processing.....</Loader>
                    </Dimmer>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <h1
                            style={{
                                display: "inline-block",
                                color: "#2185d0",
                                marginTop: -5
                            }}
                        >
                            PSR Custom Report
                        </h1>
                    </div>
                    <div style={{ marginTop: -5, display: 'flex', alignItems: 'center' }}>
                        <Label
                            style={{
                                justifyContent: 'flex-end',
                                cursor: this.isReportProcessing() ? "not-allowed" : "pointer",
                                marginLeft: 20,
                                marginTop: 5,
                                opacity: this.isReportProcessing() ? 0.5 : 1
                            }}
                            size="large"
                            color="blue"
                            onClick={this.isReportProcessing() ? undefined : this.fetchData}
                        >
                            <Icon name="database" />
                            Generate Report
                        </Label>
                        {this.isReportProcessing() && (
                            <span style={{ marginLeft: 10, color: "#f2711c", fontWeight: "bold" }}>
                                Processing...
                            </span>
                        )}
                    </div>
                </div>

                <br />
                <div style={{
                    background: '#f8f9fa',
                    border: '1px solid #e0e3e7',
                    borderRadius: 8,
                    padding: '16px 20px',
                    marginBottom: 20
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                        <h3 style={{ margin: 0, color: '#4a4a4a' }}>
                            <Icon name="filter" /> Filters
                        </h3>
                        <Label as="a" onClick={this.resetFilters} style={{ cursor: 'pointer' }}>
                            <Icon name="undo" /> Reset filters
                        </Label>
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                        gap: 20,
                        alignItems: 'start'
                    }}>
                        {this.renderMultiSelect({
                            id: 'type-select',
                            label: 'Select Type',
                            stateKey: 'selectedType',
                            options: fileType,
                            searchable: false,
                            onAfterChange: this.onTypeChanged
                        })}

                        <FormControl size="small" fullWidth>
                            <InputLabel id="month-label">Select Month</InputLabel>
                            <Select
                                labelId="month-label"
                                id="month-select"
                                value={this.state.selectedTemplate}
                                onChange={this.dropDownTemplateOnChange}
                                input={<OutlinedInput label="Select Month" />}
                                MenuProps={MenuProps}
                            >
                                {templateMonths.map((name) => (
                                    <MenuItem key={name} value={name}>
                                        <ListItemText primary={name.split('-')[1]} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {this.renderMultiSelect({
                            id: 'distributor-select',
                            label: 'Select Distributors',
                            stateKey: 'selectedDistributor',
                            options: this.state.distributors,
                            emptyText: 'No distributors found'
                        })}

                        {this.renderMultiSelect({
                            id: 'transaction-select',
                            label: 'Select Transaction Type',
                            stateKey: 'selectedTransactionType',
                            options: this.state.transactionTypes || [],
                            searchable: false
                        })}

                        {this.renderMultiSelect({
                            id: 'channel-select',
                            label: 'Select Channel',
                            stateKey: 'selectedChannel',
                            options: this.state.channel || [],
                            onOpen: this.onChannelOpen
                        })}

                        {this.renderMultiSelect({
                            id: 'category-select',
                            label: 'Select Category',
                            stateKey: 'selectedCategory',
                            options: this.state.category || [],
                            onAfterChange: this.onCategoryChanged
                        })}

                        {this.renderMultiSelect({
                            id: 'brand-select',
                            label: 'Select Brands',
                            stateKey: 'selectedBrand',
                            options: this.state.filteredBrand || [],
                            emptyText: 'Select a category first',
                            onAfterChange: this.onBrandChanged
                        })}

                        {this.renderMultiSelect({
                            id: 'brandform-select',
                            label: 'Select Brandform',
                            stateKey: 'selectedBrandform',
                            options: this.state.filteredBrandform || [],
                            emptyText: 'Select a brand first'
                        })}

                        <div className="psr-date-field">
                            <SemanticDatepicker
                                label="Start Date"
                                pointing={'bottom left'}
                                onChange={this.handleStartDateChange}
                                value={this.state.startDate || null}
                            />
                        </div>
                        <div className="psr-date-field">
                            <SemanticDatepicker
                                label="End Date"
                                pointing={'bottom left'}
                                onChange={this.handleEndDateChange}
                                value={this.state.endDate || null}
                            />
                        </div>
                    </div>
                </div>

                <h2 style={{ color: "#2185d0" }}>Pivot Data</h2>
                <div style={{ marginBottom: 10, maxWidth: 400 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                        <Icon name="columns" />
                        <h3 style={{ margin: 0 }}>Select Columns</h3>
                    </div>
                    {this.renderMultiSelect({
                        id: 'columns-select',
                        label: 'Select Columns',
                        stateKey: 'selectedFilterColumns',
                        options: this.state.filetrCol || [],
                        emptyText: 'No columns found'
                    })}
                </div>
                <br></br>
                <br></br>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    {dropdowns}
                </div>

                <h2 style={{ color: "#2185d0" }}>Download History</h2>
                <div style={{ display: "flex", overflowX: "scroll", marginTop: 20 }}>
                    {this.state.history && this.state.history.length > 0 &&
                        <ReactTable
                            noDataText="We couldn't find anything"
                            filterable={true}
                            defaultPageSize={20}
                            sortable={true}
                            style={{ width: "85vw", marginLeft: 30 }}
                            columns={columns}
                            data={this.state.history}
                        />
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchTemplates,
            psrCustomReportData,
            psrCustomReportGeneration,
            getPSRChannelList,
            psrUpdateChannels,
            psrCustomReportPivotData,
            getPsrCustomReports,
            getPsrSiteName,
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PSRReport));